/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business 基本設計シートのセル候補リストの置き場所。セルの真下に出し、下に入らないときだけ上へ返す。幅は候補の最長文字に合わせて伸びるので、画面右端からはみ出す分だけ左へ寄せる
 * @graph-connects none
 */

/** セルと候補リストの間隔 (px)。 @graph-connects none */
const GAP = 4;
/** 画面端との最小余白 (px)。 @graph-connects none */
const VIEWPORT_MARGIN = 8;
/**
 * 候補リストに最低これだけの高さは確保する (px)。
 *
 * これを下回る側には出さない。残り高さが 1 行ぶんしかない側に出すと、
 * 矢印キーで動かしても次の候補が見えず「動いていない」ように見える。
 * @graph-connects none
 */
const MIN_HEIGHT = 132;

/** 候補リストの置き場所。 */
export interface DropdownPlacement {
  /** 左端 (px)。 */
  left: number;
  /** 上端 (px)。 */
  top: number;
  /** 内部スクロールに切り替える高さ (px)。 */
  maxHeight: number;
}

/**
 * セルの真下（入らなければ真上）に候補リストを置く。
 *
 * 幅は候補の文字が折り返さない幅（`size.width`）を前提に、右端からはみ出す分だけ
 * 左へ寄せる。幅そのものは縮めない（折り返すと候補が読めなくなるため）。
 * @graph-connects none
 */
export function dropdownPlacement(
  anchor: { left: number; top: number; bottom: number },
  size: { width: number; height: number },
  viewport: { width: number; height: number },
): DropdownPlacement {
  const below = anchor.bottom + GAP;
  const spaceBelow = viewport.height - below - VIEWPORT_MARGIN;
  const spaceAbove = anchor.top - GAP - VIEWPORT_MARGIN;
  const openUp = spaceBelow < Math.min(size.height, MIN_HEIGHT) && spaceAbove > spaceBelow;
  const maxHeight = Math.max(openUp ? spaceAbove : spaceBelow, MIN_HEIGHT);
  const height = Math.min(size.height, maxHeight);
  const top = openUp ? Math.max(anchor.top - GAP - height, VIEWPORT_MARGIN) : below;
  const rightLimit = Math.max(viewport.width - size.width - VIEWPORT_MARGIN, VIEWPORT_MARGIN);
  return { left: Math.min(Math.max(anchor.left, VIEWPORT_MARGIN), rightLimit), top, maxHeight };
}
